import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import {SymbolsList} from "./reels/GameSymbol";

export class GameAssets {

    static BITMAP_FONT_OPENSANS_800: string = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP: string = "NumbersWinCountUp";
    static BITMAP_FONT_FS_INTRO_OUTRO: string = "fsIntroOutroFont";
    static GAME_MULTIPLIER: string = "GameMultiplier";
    static CAP_COUNTER: string = "vendingCapFont";
    static TOTAL_CAPS_MULTIPLIER: string = "vendingMutiFont";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_FS_INTRO_OUTRO, "fonts/bitmapfonts/fsIntroOutroFont.fnt"),
                    new BitmapFontAsset(GameAssets.GAME_MULTIPLIER, "fonts/bitmapfonts/GameMultiplier.fnt"),
                    new BitmapFontAsset(GameAssets.CAP_COUNTER, "fonts/bitmapfonts/vendingCapFont.fnt"),
                    new BitmapFontAsset(GameAssets.TOTAL_CAPS_MULTIPLIER, "fonts/bitmapfonts/vendingMutiFont.fnt")
                ]
            },
            {
                name: "jpegNormal",
                assets: [
                    new TextureAsset("jpegNormal0", "sheets/jpegNormal/jpegNormal0.json"),
                    new TextureAsset("jpegNormal1", "sheets/jpegNormal/jpegNormal1.json"),
                    new TextureAsset("jpegNormal2", "sheets/jpegNormal/jpegNormal2.json"),
                    new TextureAsset("jpegNormal3", "sheets/jpegNormal/jpegNormal3.json"),
                    new TextureAsset("jpegNormal4", "sheets/jpegNormal/jpegNormal4.json"),
                    new TextureAsset("jpegNormal5", "sheets/jpegNormal/jpegNormal5.json")
                ],
                animations: {}
            },
            {
                name: "jpegHigh",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("jpegHigh0", "sheets/jpegHigh/jpegHigh0.json"),
                    new TextureAsset("jpegHigh1", "sheets/jpegHigh/jpegHigh1.json"),
                    new TextureAsset("jpegHigh2", "sheets/jpegHigh/jpegHigh2.json")
                ],
                animations: {
                    "sideReelSmoke": "features/sideReel/sideReelSmoke/sideReelSmoke_"
                }
            },
            {
                name: "pngNormal",
                assets: [
                    new TextureAsset("pngNormal0", "sheets/pngNormal/pngNormal0.json"),
                    new TextureAsset("pngNormal1", "sheets/pngNormal/pngNormal1.json"),
                    new TextureAsset("pngNormal2", "sheets/pngNormal/pngNormal2.json"),
                    new TextureAsset("pngNormal3", "sheets/pngNormal/pngNormal3.json"),
                    new TextureAsset("pngNormal4", "sheets/pngNormal/pngNormal4.json"),
                    new TextureAsset("pngNormal5", "sheets/pngNormal/pngNormal5.json"),
                    new TextureAsset("pngNormal6", "sheets/pngNormal/pngNormal6.json"),
                    new TextureAsset("pngNormal7", "sheets/pngNormal/pngNormal7.json")

                ],
                animations: {
                    "particle": "particle",
                    "winSplash": "winSplash/winSplash",
                    "wayText": "waysTextImages/wayImg",
                    "waysText": "waysTextImages/waysImg",
                    "fsIntroText": "bonusGame/fsIntroText",
                    "sfsIntroText": "bonusGame/sfsIntroText",
                    "upgradeText": "bonusGame/upgradeText",
                    "satanSpinBigSymbol": "bonusGame/satanSpinIntro",
                    "blackTrimmedOverlay": "black1680"
                }
            },
            {
                name: "pngHigh",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("pngHigh0", "sheets/pngHigh/pngHigh0.json"),
                    new TextureAsset("pngHigh1", "sheets/pngHigh/pngHigh1.json"),
                    new TextureAsset("pngHigh2", "sheets/pngHigh/pngHigh2.json"),
                    new TextureAsset("pngHigh3", "sheets/pngHigh/pngHigh3.json")
                ],
                animations: {
                    "gameMultBg": "boards/multiBoard/multiBoard",
                    "gameWaysBg": "boards/waysBoard/waysBoard",
                    "ammoHead": "features/sideReel/multipliers/multiBazucaLMagazine",
                    "ammoSeq": "features/sideReel/multipliers/multiplierTrail/multiplierTrail_",
                    "gameLogo": "gameLogo/gameLogo",
                    "machineBannerImg": "features/pickNclick/layers/theCapWinMachine",
                    "topReelGlassOverlay": "boards/tunnelGlass"
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations: {}
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset(SymbolsList.M1, "spine/symbols/M1.json"),
                    new SpineAsset(SymbolsList.M2, "spine/symbols/M2.json"),
                    new SpineAsset(SymbolsList.M3, "spine/symbols/M3.json"),
                    new SpineAsset(SymbolsList.M4, "spine/symbols/M4.json"),
                    new SpineAsset(SymbolsList.M5, "spine/symbols/M5.json"),
                    new SpineAsset(SymbolsList.L1, "spine/symbols/L1.json"),
                    new SpineAsset(SymbolsList.L2, "spine/symbols/L2.json"),
                    new SpineAsset(SymbolsList.L3, "spine/symbols/L3.json"),
                    new SpineAsset(SymbolsList.L4, "spine/symbols/L4.json"),
                    new SpineAsset(SymbolsList.L5, "spine/symbols/L5.json"),
                    new SpineAsset(SymbolsList.WILD, "spine/symbols/W.json"),
                    new SpineAsset(SymbolsList.S1, "spine/symbols/S1.json"),
                    new SpineAsset(SymbolsList.S2, "spine/symbols/S2.json"),
                    new SpineAsset(SymbolsList.LAUNCH, "spine/symbols/symLaunch.json"),
                    new SpineAsset(SymbolsList.LAUNCH_WILD, "spine/symbols/symLaunch.json"),
                    new SpineAsset(SymbolsList.XBOMB, "spine/symbols/symBomb.json"),
                    new SpineAsset(SymbolsList.XNUDGE, "spine/symbols/symNudge.json"),
                    new SpineAsset(SymbolsList.MAGA_CAP, "spine/symbols/symCap.json"),


                    new SpineAsset("featureDead", "spine/symbols/topReel/featureDead.json"),
                    new SpineAsset("featureWild", "spine/symbols/topReel/featureWild.json"),
                    new SpineAsset("featureXNudge", "spine/symbols/topReel/featureXNudge.json"),
                    new SpineAsset("featureLaunch", "spine/symbols/topReel/featureLaunch.json"),
                    new SpineAsset("featureCap", "spine/symbols/topReel/featureCap.json"),

                    new SpineAsset("sideReelRays", "spine/features/sideReel/sideReelRays.json"),
                    new SpineAsset("featureBlank", "spine/features/sideReel/blank.json"),
                    new SpineAsset("featureXBomb", "spine/features/sideReel/xBomb.json"),
                    new SpineAsset("featureXSplit", "spine/features/sideReel/xSplit.json"),
                    new SpineAsset("featureMultipliers", "spine/features/sideReel/multiplier.json"),

                    new SpineAsset("bigWin_0", "spine/bigWins/bigWin_intro.json"),
                    new SpineAsset("bigWin_1", "spine/bigWins/bigWin_1.json"),
                    new SpineAsset("bigWin_2", "spine/bigWins/bigWin_2.json"),
                    new SpineAsset("bigWin_3", "spine/bigWins/bigWin_3.json"),
                    new SpineAsset("bigWin_4", "spine/bigWins/bigWin_4.json"),
                    new SpineAsset("bigWin_5", "spine/bigWins/bigWin_5.json"),

                    new SpineAsset("bgSpine", "spine/backgrounds.json"),
                    new SpineAsset("satanSpine", "spine/satanBackground.json"),
                    new SpineAsset("bgDoors", "spine/doors.json"),
                    new SpineAsset("pickClickBackgroundSpine", "spine/features/pickNclick/pickNclickMachine_back.json"),
                    new SpineAsset("pickClickForegroundSpine", "spine/features/pickNclick/pickNclickMachine_frontPanel.json"),
                    new SpineAsset("redCap", "spine/features/pickNclick/pickNclick_capRed.json"),
                    new SpineAsset("yelCap", "spine/features/pickNclick/pickNclick_maxCap.json"),

                    new SpineAsset("winCap", "spine/maxWin_.json"),
                    new SpineAsset("multiBoardGlow", "spine/multisBoardHL.json"),
                    new SpineAsset("tankSpine", "spine/mainGameTank.json")
                ]
            }
        ]
    };
}